var render = function render(){var _vm=this,_c=_vm._self._c;return _c('apexChart',{attrs:{"type":"line","height":"350","options":_vm.chartOptionsComputed,"series":_vm.clientDates.series}})
}
var staticRenderFns = []

export { render, staticRenderFns }